import { WINDOW, REPLAY_SESSION_KEY } from '../constants.js';
import { makeSession } from './Session.js';
/**
 * Fetches a session from storage
 */

function fetchSession() {
  var hasSessionStorage = ('sessionStorage' in WINDOW);

  if (!hasSessionStorage) {
    return null;
  }

  try {
    // This can throw if cookies are disabled
    var sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);

    if (!sessionStringFromStorage) {
      return null;
    }

    var sessionObj = JSON.parse(sessionStringFromStorage);
    return makeSession(sessionObj);
  } catch (e) {
    return null;
  }
}

export { fetchSession };